import { useState } from "react";
import { TextField, Button, Paper, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Api from "./Api/Api.js";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const res = await Api.post("/login", {
        uname: username,
        pwd: password,
      });

      console.log(res.data);

      if (res.data.status === true) {
        const user = res.data.user;

        localStorage.setItem("user", JSON.stringify(user));

        console.log("LOGIN SUCCESS:", user);

        navigate("/app");
      }
    } catch (err) {
      console.log("FULL ERROR:", err);
      console.log("RESPONSE:", err.response);
      console.log("REQUEST:", err.request);
      alert("Login failed");
    }
  };

  return (
    <Paper style={{ padding: 30, maxWidth: 400, margin: "100px auto" }}>
      <Typography variant="h5">Login</Typography>

      <TextField
        fullWidth
        label="Username"
        margin="normal"
        onChange={(e) => setUsername(e.target.value)}
      />

      <TextField
        fullWidth
        type="password"
        label="Password"
        margin="normal"
        onChange={(e) => setPassword(e.target.value)}
      />

      <Button fullWidth variant="contained" onClick={handleLogin}>
        Login
      </Button>
    </Paper>
  );
}
